module.exports = __webpack_public_path__ + "img/login-bg.8b87f9dc.jpg";